import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const PROCESSED_ITEM_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.PROCESSED_ITEM,
  false
);

export const processedItemApi = {
  processedItemForm: () => apiClient.get(`${PROCESSED_ITEM_BASE}/form`),

  editProcessedItemForm: Id =>
    apiClient.get(
      `${PROCESSED_ITEM_BASE}/form?is_edit=true&processed_item_id=${Id}`
    ),

  createProcessedItem: combinedData =>
    apiClient.post(`${PROCESSED_ITEM_BASE}`, combinedData),

  updateProcessedItem: (processed_id, combinedData) =>
    apiClient.put(`${PROCESSED_ITEM_BASE}/${processed_id}`, combinedData),

  updateProcessedItemStatus: (processed_id, isActive) =>
    apiClient.post(
      `${PROCESSED_ITEM_BASE}/status?id=${processed_id}&isActive=${isActive}`
    )
};
